import React, { Component } from 'react';
import { connect } from 'react-redux';
import './forms.css';
import * as repositoryActions from '../../../Store/Actions/repositoryActions';

import TextBox from '../TextBox/textbox';
import Button from '../Button/button';
import ComboBox from '../ComboBox/combobox';
import DropZone from '../DropZone/dropzone';

/*
PARAMETERS :
  create : true/false
  object : {} // object to update or null if create = true,
  reservedValue : {COLUMNNAME:[ARRAY OF RESERVED VALUE]}
*/
class paysForm extends Component {
  constructor(props) {
    super(props);
    // State is in reducers
    this.state = {
      page:0,
      create:true,
      endPoint:"PAYS",
      blankObject:{
        AC_001: 0,
        ARCS: 0,
        CAPITAL: "",
        CONTINENT_ARCS: 0,
        DOMAINE: ".    ",
        FILE: [],
        FLAG: 0,
        HISTORIQUE: 0,
        INDICATIF: "+ ",
        ISO_3166_1: 0,
        ISO_3166_1_ALPHA2: "",
        ISO_3166_1_ALPHA3: "",
        IU: "R",
        NSYS: 4,
        SIT: 0,
        SUPERFICIE_KM2: 0,
        Session: {},
        SessionIDE: "",
        Status: 0,
        WORDING: "",
      }
    };

  }

  // BUILDING METHOD DO NOT CHANGE
  componentDidMount = () =>{
    var node = {...this.props.node};
    // GET THE OBJECT IF ID is provided
    
    if(this.props.id > 0){
      this.props.get_single_object(this.props.sessionId,this.props.id,this.state.endPoint);
      this.setState({create:false});
    }else{
      this.setState({create:true});
      this.props.onCreateBlank(this.state.blankObject);
    }

    node.ARCS_TP_N3 = this.props.parentId;
    this.props.get_list_object(this.props.sessionId,"EN3",node,true,this.state.page);
  }


  // INNER METHOD 

  //GENERIC DO NOT CHANGE
  onClickCancel = () =>{
    this.props.onCancelForm();
  }

  // MAY CHANGE
  // ADD ALERT MANAGEMENT FOR UNIQUE REF
  onClickValid = () =>{
    var object = this.props.newObject;
    if(this.state.create){
      // CHECK RESERVED VALUE UNIQUE ISO_3166_1_ALPHA2
          if(this.props.dataSet.map(item=>item.ISO_3166_1_ALPHA2).includes(object.ISO_3166_1_ALPHA2)){
            alert("the value : "+object.ISO_3166_1_ALPHA2+ " should be unique and is already in use for column :"+"ISO_3166_1_ALPHA2");
          }else{
            this.props.onSave(object,true);
          }
    }else{
      this.props.onSave(object,true);
    }
  }

  //GENERIC DO NOT CHANGE
  onUpdateValue = (columnName,e) =>{
    this.props.onUpdateValue(columnName,e);
  }

  //GENERIC
  onSelectedItems = (ids) =>{
    this.props.onUpdateValue("CONTINENT_ARCS",ids[0]);
  }

  readFileByteArray = (files) =>{
    new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
          resolve(event.target.result);
      };

      reader.onerror = (err) => {
          reject(err);
      };

      reader.readAsArrayBuffer(files[0]);
    }).then(ba=>{
      this.props.onUpdateValue("FILE",ba);
    });

    
  }

  render() {
 
    var content = this.props.newObject !== null ?
    <div>
        <div className="form-section">
          <div className="section-header">
            <span className="section-name">Identification (id : {this.state.create?0:this.props.newObject.ARCS})</span>
            <div className="section-status valid"></div>
          </div>
          <div className="section-body">
            {/* ISO 2 */}
            <div className={!this.state.create ? "section-item column-3 readOnly": "section-item column-3"}>
            <label>ISO 2</label>
            <TextBox 
              config={
                {
                  mask:"aa", 
                  color:"#999",
                  readOnly:this.state.create?false:true, 
                  maxLength:2, 
                  textAlign:"left"
                }
              }
              updateValue={this.onUpdateValue.bind(this,"ISO_3166_1_ALPHA2")}
              value = {this.props.newObject !== undefined? this.props.newObject["ISO_3166_1_ALPHA2"]:""}
            />
          </div>
            {/* ISO 3 */}
            <div className="section-item column-3">
            <label>ISO 3</label>
            <TextBox 
              config={
                {
                  mask:null, 
                  color:"#999",
                  readOnly:false, 
                  maxLength:3, 
                  textAlign:"left"
                }
              }
              updateValue={this.onUpdateValue.bind(this,"ISO_3166_1_ALPHA3")}
              value = {this.props.newObject !== undefined?this.props.newObject["ISO_3166_1_ALPHA3"]:""}
            />
          </div>
            {/* ISO 3166 */}
            <div className="section-item column-3">
              <label>ISO 3166</label>
              <TextBox 
                config={
                  {
                    mask:null, 
                    color:"#999",
                    readOnly:false, 
                    maxLength:5, 
                    textAlign:"left"
                  }
                } 
                updateValue={this.onUpdateValue.bind(this,"ISO_3166_1")}
                value = {this.props.newObject !== undefined? this.props.newObject["ISO_3166_1"]:""}
              />
            </div>
            {/* Wording */}
            <div className="section-item column-1">
              <label>Name</label>
              <TextBox 
                config={
                  {
                    mask:null, 
                    color:"#999",
                    readOnly:false, 
                    maxLength:null, 
                    textAlign:"left"
                  }
                } 
                updateValue={this.onUpdateValue.bind(this,"WORDING")}
                value = {this.props.newObject !== undefined? this.props.newObject["WORDING"]:""}
              />
            </div>
            {/* Continent */}
            <div className="section-item column-2">
              <label>Continent</label>
              {this.props.listOptions !== null?
                <ComboBox 
                  onSelectItem={this.onSelectedItems.bind()}
                  listItem={this.props.listOptions !== undefined?this.props.listOptions:[]}
                  selectedItemIds={[this.props.newObject.CONTINENT_ARCS]}
                  config={
                    {
                      id:"ARCS",
                      isSelectable:true,
                      multiple:false,
                      columns:[
                        {name:"CODE",type:"text"},{name:"WORDING",type:"number"}
                      ],
                      actions:[]
                    }
                  }
                />
              :null}
            </div>
          </div>
        </div>
        <div className="form-section">
          <div className="section-header">
            <span className="section-name">Informations</span>
            <div className="section-status valid"></div>
          </div>
          <div className="section-body">
            {/* Capital */}
            <div className="section-item column-3">
            <label>Capital</label>
            <TextBox 
              config={
                {
                  mask:null, 
                  color:"#999",
                  readOnly:false, 
                  maxLength:null, 
                  textAlign:"left"
                }
              }
              updateValue={this.onUpdateValue.bind(this,"CAPITAL")}
              value = {this.props.newObject !== undefined? this.props.newObject["CAPITAL"]:""}
            />
          </div>
            {/* Superficie */}
            <div className="section-item column-3">
            <label>Superficie KM2</label>
            <TextBox 
              config={
                {
                  mask:"99999999999", 
                  color:"#999",
                  readOnly:false, 
                  maxLength:null, 
                  textAlign:"left"
                }
              }
              updateValue={this.onUpdateValue.bind(this,"SUPERFICIE_KM2")}
              value = {this.props.newObject !== undefined?this.props.newObject["SUPERFICIE_KM2"]:""}
            />
          </div>
            {/* DOMAINE */}
            <div className="section-item column-3">
              <label>Domaine</label>
              <TextBox 
                config={
                  {
                    mask:".aa*aa", 
                    color:"#999",
                    readOnly:false, 
                    maxLength:5, 
                    textAlign:"left"
                  }
                } 
                updateValue={this.onUpdateValue.bind(this,"DOMAINE")}
                value = {this.props.newObject !== undefined? this.props.newObject["DOMAINE"]:""}
              />
            </div>
            {/* INDICATIF */}
            <div className="section-item column-3">
              <label>Indicatif</label>
              <TextBox 
                config={
                  {
                    mask:"+999", 
                    color:"#999",
                    readOnly:false, 
                    maxLength:null, 
                    textAlign:"left"
                  }
                } 
                updateValue={this.onUpdateValue.bind(this,"INDICATIF")}
                value = {this.props.newObject !== undefined? this.props.newObject["INDICATIF"]:""}
              />
            </div>
            {/* ICON */}
            <div className="section-item column-3">
              <label>Icon File</label>
              <DropZone getFile={this.readFileByteArray.bind()}></DropZone>
            </div>
            <div className="section-item column-3">
              {this.props.newObject !== undefined? 
              <img className="pays-icon" src={"data:image/ico;base64, "+ btoa(String.fromCharCode.apply(null, new Uint8Array(this.props.newObject["FILE"]))) } />
              :
              null
              }
              
            </div>
          </div>
        </div>
        <div className="form-section">
          <div>
            <Button 
              preventMultipleClick={0} 
              config={
                {
                  isEnabled:true,
                  icon:"check",
                  text:"save change",
                  color:null,
                  textAlign:"center",
                  bgcolor:null
                }
              } 
              OnClickElement={this.onClickValid.bind(this)}
            />
          </div>
        </div>
      </div>
    :
      null
    ;

    return (
      <div className="form-container" >
        {content}
      </div>
         
    );
  }
}

  const mapStateToProps = (state) => {    
    return {  
      newObject:state.apiReducer.newObject,
      sessionId: state.apiReducer.sessionId,
      dataSet:state.apiReducer.workingData,
      listOptions:state.apiReducer.listOptions,
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return { 
      get_single_object: (sessionId,id,endPoint) =>dispatch(repositoryActions.get_single_object(sessionId,id,endPoint)),
      onUpdateValue:(columnName,e)=>dispatch(repositoryActions.onUpdateValue(columnName,e)),
      onCreateBlank:(object)=>dispatch(repositoryActions.onCreateBlank(object)),
      get_list_object: (sessionId,endPoint,node,getOptions,page) =>dispatch(repositoryActions.get_list_object(sessionId,endPoint,node,getOptions,page)),
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(paysForm);